import { render, staticRenderFns } from "./Coin2dEdit.vue?vue&type=template&id=057fa412&scoped=true&"
import script from "./Coin2dEdit.vue?vue&type=script&lang=ts&"
export * from "./Coin2dEdit.vue?vue&type=script&lang=ts&"
import style0 from "./Coin2dEdit.vue?vue&type=style&index=0&id=057fa412&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057fa412",
  null
  
)

export default component.exports